<template>
  <div
    class="
      tw-fixed
      tw-top-0
      tw-left-0
      tw-w-full
      tw-flex
      tw-justify-between
      tw-items-center
      tw-px-6
      tw-py-3
      tw-border-b
      tw-border-t-0
      tw-border-l-0
      tw-border-r-0
      tw-border-solid
      tw-border-sf-snow-darker
      tw-z-50
      tw-bg-sf-snow-lighter
    "
  >
    <div class="tw-text-lg tw-font-medium">
      {{ copy.title }}
    </div>
    <div class="tw-flex tw-gap-4">
      <SfButtonDs variant="secondary" @click="switchToPreparationMode">
        <span class="tw-flex tw-items-center tw-gap-2">
          <span>{{ copy.presenting }}</span>
          <SfToggle :model-value="isPresenting" :icons="false" @click.prevent />
        </span>
      </SfButtonDs>

      <NewRemarkButton
        owner-type="ClientMeeting"
        :owner-id="pageData.clientMeetingId"
        :hide-period-selector="true"
        :selected-tag-ids="selectedTagIds"
        :is-client-meeting-remark="true"
        modal-size="l"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, ref } from 'vue'

import type { PresentPageData } from '@app/application/client_meetings/types'

import { useTalkingPointTag } from '@app/application/client_meetings/composables/use-talking-point-tag'
import { SfButtonDs } from '@silverfin/ui-components'
import SfToggle from '@app/shared/vue/components/sf-toggle.vue'
import NewRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button.vue'

import useI18n from '@app/shared/vue/composables/use-I18n'
import * as PrepareApi from '@app/application/client_meetings/api/prepare'
import { SfLog } from '@app/adapters/logger'

const pageData = inject('pageData') as PresentPageData

const I18n = useI18n()
const copy = {
  title: I18n.t('client_meetings.present.title'),
  presenting: I18n.t('client_meetings.present.presenting'),
}

const { talkingPointTagIds: selectedTagIds } = useTalkingPointTag()

const isPresenting = ref(true)

async function switchToPreparationMode() {
  // One click on the label reaches this button twice, through the label and the checkbox it forwards to
  if (!isPresenting.value) return

  isPresenting.value = false
  try {
    await PrepareApi.disablePresentationMode()

    window.Turbolinks.visit(
      window.Silverfin.Routes.client_meetings_prepare_path(
        window.Silverfin.currentFirmId,
        window.Silverfin.currentCompanyId
      )
    )
  } catch (error) {
    SfLog.error('Failed to disable presentation mode', { error })
    isPresenting.value = true
  }
}
</script>
